/**********************************| Document Ready Start |****************************/
$(document).ready(function () {
    collection_slider();
    $('.readmore').click(function(){
      $('.product__text_short').addClass('show_more');
      $(this).toggle();
      $('.readless').show();
    });
    
    
    $('.readless').click(function(){
      $('.product__text_short').removeClass('show_more');
      $(this).toggle();
      $('.readmore').show();
    });

    /*--------------| FAQ Accordian start |------------------------*/ 
    $('.FAQQues').click(function() {
      if ($(this).hasClass('accoMinus')) {
        $(this).next().slideUp();
        $(this).removeClass('accoMinus');
        $(this).parent().removeClass('open-box');
      } else {
        $('.FAQQues').removeClass('accoMinus');
        $(this).addClass('accoMinus');
        $('.FAQAns').removeClass('open-box');
        $(this).parent().addClass('open-box');
        $('.FAQAns').slideUp();
        $(this).next().slideDown();      
      }
    });
    /*--------------| FAQ Accordian end |------------------------*/ 


});
/**********************************| Document Ready End |****************************/

/**********************************| Window Load Start |****************************/
$(window).load(function () {     
        
});
/**********************************| Window Load End |****************************/

/**********************************| Window Resize Start |****************************/
$(window).resize(function(){
});
/**********************************| Window Resize End |****************************/


document.addEventListener('DOMContentLoaded', function () {
  if (!window.jQuery) return;

  /* Tabs */
  document.querySelectorAll('.category-tabs-section').forEach(section => {

    const tabs = section.querySelectorAll('.category-tab');
    const panels = section.querySelectorAll('.category-tab-panel');

    tabs.forEach(tab => {
      tab.addEventListener('click', function () {

        // Remove active only inside THIS section
        tabs.forEach(t => t.classList.remove('is-active'));
        panels.forEach(p => p.classList.remove('is-active'));

        this.classList.add('is-active');
        const panel = section.querySelector(`#${this.dataset.tab}`);
        panel.classList.add('is-active');

        // Fix slick width
        if (window.jQuery && jQuery(panel).find('.js-tab-slider').hasClass('slick-initialized')) {
          jQuery(panel).find('.js-tab-slider').slick('setPosition');
        }
      });
    });

  });  

  /* Slick Init */
  $('.js-tab-slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,    
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 1200,
    responsive: [        
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows:true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows:true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows:true
      }
    }
    ]
  });

  $('.js-usp-slider').not('.slick-initialized').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 990, settings: { slidesToShow: 2 } },
      { breakpoint: 750, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } }
    ]
  });
  
  $('.js-team-slider').not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    appendArrows: $('.team-slider-section .slider-controls'),
    appendDots: $('.team-slider-section .slider-controls .slider-dots'),
    prevArrow: '<div title="Previous" class="custom-left slick-prev trans"></div>',
    nextArrow: '<div title="Next" class="custom-right slick-next trans"></div>', 
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    fade: true,
    adaptiveHeight: false
  });

  $('.js-testimonials-slider').not('.slick-initialized').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    centerMode: true,
    responsive: [
      { breakpoint: 990, settings: { slidesToShow: 2, centerMode: false } },
      { breakpoint: 750, settings: { slidesToShow: 1, centerMode: false } }
    ]
  });

  $('.marketplace-logos').not('.slick-initialized').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000
  });
  

});

function collection_slider(){
  if($.fn.slick){
     if(!$('.collection-slider').hasClass('slick-initialized')){
      $('.collection-slider').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        appendArrows: $('.collections-slider-section .slider-controls'),
        appendDots: $('.collections-slider-section .slider-controls .slider-dots'),
        prevArrow: '<div title="Previous" class="custom-left slick-prev trans"></div>',
        nextArrow: '<div title="Next" class="custom-right slick-next trans"></div>', 
        autoplay: false,
        autoplaySpeed: 2000,
        speed: 1200,
        responsive: [        
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows:true
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows:true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows:true
          }
        }
        ]
      });
    }
  }
}